import ModelSubMenu from './ModelSubMenu';
import ModelProductsSubMenu from './ModelProductsSubMenu';
import SpecialProductsModelSubMenu from './SpecialProductsModelSubMenu';
import SpecialProductsSubMenu from './SpecialProductsSubMenu';
import ProductsList from './ProductsList';

const ForecastSidebarMenu = () => {
  return (
    <div>
      <ModelSubMenu />
      <ModelProductsSubMenu />

      {/* <hr />
      <SpecialProductsModelSubMenu />
      <SpecialProductsSubMenu /> */}

      <hr />
      <ProductsList />
    </div>
  );
};

export default ForecastSidebarMenu;
